import { Cpu } from 'lucide-react';
import { useTranslation } from 'react-i18next';

// "Generated by [model]" — the model that ACTUALLY served an artifact (from usage_events via
// get_project_state.served_models). Renders nothing until a served model is known.
export function ServedModelBadge({ model, testId = 'served-model-badge' }) {
  const { t } = useTranslation();
  if (!model || !model.model_id) return null;
  return (
    <span
      className="inline-flex items-center gap-1.5 text-xs font-medium px-2.5 py-1 rounded-full bg-muted text-muted-foreground border border-border"
      data-testid={testId}
      title={model.provider ? `${model.provider} · ${model.model_id}` : model.model_id}
    >
      <Cpu className="h-3.5 w-3.5" />
      {t('common.generatedBy', { model: model.model_id })}
    </span>
  );
}
